import { render } from "./BattleCharaStatus.vue?vue&type=template&id=19a25b36&scoped=true"
import script from "./BattleCharaStatus.vue?vue&type=script&lang=js"
export * from "./BattleCharaStatus.vue?vue&type=script&lang=js"

import "./BattleCharaStatus.vue?vue&type=style&index=0&id=19a25b36&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a25b36"]])

export default __exports__